import api from './api';

export function getLinesOfCredit() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/lineas-credito`);
}

export function getCreditsByAdvisor(data,idOficina) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/creditos-activos/${idOficina}`, data);
}

export function getCreditById(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}`)
}

export function endCreditProcess(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/${data.subCanal}/establish`, data);
}

export function getCausalesAnulacion() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/causales-anulacion`)
}

export function saveCreditAnulacion(data) {
  return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/anulacion`, data);
}

export function getLastCreditByClient(idClient) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clientes/${idClient}/ultimocredito`)
}

export function getAlertsByCredit(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/alertas/${idCredit}`)
}
